<template>
    <div>
        <div
            v-for="(file, index) in normalizedFiles"
            :key="`${file.path}-${index}`"
            class="document-attachment-row"
        >
            <a class="text-truncate document-attachment-name"
               :href="file.url"
               target="_blank"
               :title="file.name">
                {{ file.name }}
            </a>
            <button
                v-if="isImage(file.url)"
                type="button"
                class="btn btn-sm btn-primary document-attachment-edit"
                :title="$t('edit')"
                @click.prevent="openEditor(file.path)"
            >
                <i class="fas fa-edit"></i>
            </button>
        </div>
        <span v-if="!normalizedFiles.length">-</span>
    </div>
</template>

<script>
import HelperMixin from "../../../../../../common/Mixin/Global/HelperMixin";
import {urlGenerator} from "../../../../../../common/Helper/AxiosHelper";

export default {
    name  : "DocumentAttachmentColumn",
    mixins: [HelperMixin],
    props : {
        value: {
            default: () => []
        },
        rowData: {
            type   : Object,
            default: () => ({})
        }
    },
    computed: {
        files() {
            return Array.isArray(this.value) ? this.value : [];
        },
        normalizedFiles() {
            return this.files.map(path => ({
                path,
                url : urlGenerator(path),
                name: this.getFileName(path)
            }));
        },
        imageFiles() {
            return this.files.filter(path => this.isImage(path));
        }
    },
    methods: {
        openEditor(path) {
            this.$hub.$emit('open-document-image-editor', {
                rowData     : this.rowData,
                files       : this.imageFiles,
                selectedPath: path
            });
        }
    }
}
</script>

<style scoped>
.document-attachment-row {
    display: flex;
    align-items: center;
    min-width: 220px;
    max-width: 360px;
    gap: 0.5rem;
}

.document-attachment-row + .document-attachment-row {
    margin-top: 0.35rem;
}

.document-attachment-name {
    min-width: 0;
}

.document-attachment-edit {
    width: 28px;
    height: 28px;
    padding: 0;
    flex: 0 0 28px;
}
</style>
